import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Card,
  Button,
  Modal,
  Row,
  Col,
  Form,
  Table,
  Pagination,
  Container
} from 'react-bootstrap';
import axios from 'axios';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { var_api } from '../../constant';
import Swal from "sweetalert2";
import Loader from "../Loader";

const getFormattedDate = (daysBeforeToday) => {
    const date = new Date();
    date.setDate(date.getDate() - daysBeforeToday);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

const SalesSummary = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(25);
  const [showCalendar, setShowCalendar] = useState(false);
  const [popupLast30Days, setPopupLast30Days] = useState(false);
  const [startDate, setStartDate] = useState(getFormattedDate(30));
  const [endDate, setEndDate] = useState(getFormattedDate(0));
  const [clientsData, setClientsData] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchClientSummary();
    
  }, [startDate, endDate]);



  const fetchClientSummary = async () => {
    setLoading(true); 
    try {
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const tokens = localStorage.getItem('token');
      const response = await axios.get(`${var_api}/api/booking/sales-summary/${formattedStartDate}/${formattedEndDate}`, {
        headers: { Authorization: `${tokens}` }
      });
      setClientsData(response.data);
      setPopupLast30Days(false);
      setLoading(false); 
    } catch (error) {
      setLoading(false); 
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    }
  };


  const formatToDDMMYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const filteredUsers = clientsData.filter((client) => {
    const serviceName = String(client.service_name || "").toLowerCase();
    const salesQty = String(client.sales_qty || "").toLowerCase();
    const serviceSold = String(client.service_sold || "").toLowerCase();
    const description = String(client.description || "").toLowerCase();
    return (
      serviceName.includes(searchQuery.toLowerCase()) ||
      salesQty.includes(searchQuery.toLowerCase()) ||
      serviceSold.includes(searchQuery.toLowerCase()) ||
      description.includes(searchQuery.toLowerCase())
    );
  });

  const totalPages = Math.ceil(filteredUsers.length / pageSize);
  const paginatedUsers = filteredUsers.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const handleRoute = () => history.push('/reports');
  const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const nextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const exportServiceDataToPDF = () => {
    const doc = new jsPDF();
    const columns = ["S.No", "Service Name", "Sales Quantity", "Service Sold", "Description"];
    const rows = paginatedUsers.map((client, index) => [
      index + 1,
      client.service_name,
      client.sales_qty,
      client.service_sold,
      client.description
    ]);
    doc.autoTable({ head: [columns], body: rows, theme: 'grid', startY: 10 });
    doc.save('ServiceData.pdf');
  };

  const downloadExcel = () => {
    const data = paginatedUsers.map((client, index) => ({
      'S.No.': index + 1,
      'Service Name': client.service_name,
      'Sales Quantity': client.sales_qty,
      'Service Sold': client.service_sold,
      'Description': client.description
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'SalesSummary');
    XLSX.writeFile(wb, 'sales_summary.xlsx');
  };

  return (
    <>
    {loading && <Loader />} 
    <Container className="container mx-auto" style={{ maxWidth: '90%' }}>
    <div className="header mb-4 text-center">
    <Button variant="dark" onClick={handleRoute} className="mb-4 float-start">
            <i className="bx bx-arrow-back"></i> Back
        </Button>
        <h2>Sales summary</h2>
        <p>Sales quantities and value, excluding gift card sales.</p>
    </div>

    <div className="filters mb-4 d-flex justify-content-between">
        <Button variant="dark" onClick={() => setPopupLast30Days(true)}>Date Filter</Button>
        <Form.Control
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search"
            style={{ width: '200px' }} // Adjust width as needed
        />
    </div>

    <Modal show={popupLast30Days} onHide={() => setPopupLast30Days(false)} centered>
        <Modal.Header closeButton>
            <Modal.Title>Filter Last 30 Days</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row className="mb-4">
                <Col>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </Col>
                <Col>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </Col>
            </Row>
            <Row className="justify-content-end">
                <Button variant="dark" onClick={fetchClientSummary}>Apply</Button>
                <Button variant="outline-secondary" onClick={() => setPopupLast30Days(false)} className="ms-2">Cancel</Button>
            </Row>
        </Modal.Body>
    </Modal>

    <div className="live-preview">
        <Table responsive striped bordered hover className="w-100">
            <thead>
                <tr>
                    <th>S.No.</th>
                    <th>Service Name</th>
                    <th>Sales Quantity</th>
                    <th>Service Sold</th>
                    <th>Description</th>
                </tr>
            </thead>
            <tbody>
                {paginatedUsers.length > 0 ? (
                    paginatedUsers.map((client, index) => (
                        <tr key={client.service_name}>
                            <td>{(currentPage - 1) * pageSize + index + 1}</td>
                            <td>{client.service_name}</td>
                            <td>{client.sales_qty}</td>
                            <td>{client.service_sold}</td>
                            <td>{client.description}</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" className="text-center">No Data Available</td>
                    </tr>
                )}
            </tbody>
        </Table>
    </div>

   
  <div className='d-flex justify-content-between align-items-center mt-4'>
    <div className="d-flex justify-content-center mt-4">
        <Button onClick={exportServiceDataToPDF} variant="dark">Download as PDF</Button>
        <Button onClick={downloadExcel} variant="dark" className="ms-2">Download as Excel</Button>
    </div>
    <Pagination className="mt-0">
        <Pagination.Prev onClick={prevPage} disabled={currentPage === 1}>Previous</Pagination.Prev>
        {[...Array(totalPages).keys()].map((_, idx) => (
            <Pagination.Item key={idx} active={currentPage === idx + 1} onClick={() => setCurrentPage(idx + 1)}>
                {idx + 1}
            </Pagination.Item>
        ))}
        <Pagination.Next onClick={nextPage} disabled={currentPage === totalPages}>Next</Pagination.Next>
    </Pagination>
    </div>
</Container>
</>
  );
};

export default SalesSummary;
